import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const NewBadge = ({
  variant,
  className
}: {
  variant: BadgeVariant;
  className?: string;
}) => {
  return (
    <Badge variant={variant} size={BadgeSize.SM} className={className}>
      New
    </Badge>
  );
};
